<template>
	<div>
	  <div class="c-accommodation-search">
		  <a v-if="accommodation && accommodation.meta && accommodation.meta.type !== '' && accommodation.meta.type === 'private'"
		     @click.prevent="showModal"
		     href="#"
		     class="btn btn--modal btn--blank">
			  <img src="/src/img/accommodation/welcome-logo.png" alt="">
		  </a>

		  <div
	      v-if="accommodation.meta.main_picture == undefined "
	      class="c-accommodation-search__img-holder"
	    >
	      <picture>
	        <img
	          class="c-accommodation-search__img"
	          src="/src/img/accommodation/no_image.png"
	          alt="alt"
	        />
	      </picture>
	    </div>
	    <div
	      v-else-if="accommodation.meta.main_gallery !==  undefined"
	      class="c-accommodation-search__img-holder accommodation-search-slider"

	    >
			<a v-if="accommodation && accommodation.meta && accommodation.meta.type !== '' && accommodation.meta.type === 'private'" @click.prevent="showModal" href="#" class="btn btn--modal btn--blank">
				<img src="/src/img/accommodation/welcome-logo.png" alt="">
			</a>
	        <swiper :options="swiperOption" ref="mySwiper" class="">
	          <swiper-slide>
	            <picture>
	              <img
	                class="c-accommodation-search__img"
	                :src="accommodation.meta.main_picture.mainImagePath"
	                alt="alt"
	              />
	            </picture>
	          </swiper-slide>
	          <swiper-slide v-for="image in accommodation.meta.main_gallery"
	            :key="image.id">
	              <picture>
	                <img
	                  class="c-accommodation-search__img"
	                  :src="'/en/vdatastore/image?id=' + image.id + '&variation=720x720'"
	                  alt="alt"
	                />
	            </picture>
	          </swiper-slide>
	          <div class="swiper-pagination" slot="pagination"></div>

	          <div class="swiper-button-next" slot="button-next"><svg class="swiper-button__arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8">
	                            <path fill="#1D1D1B" fill-rule="evenodd" d="M16 4l-4-4v3H0v2h12v3z"/>
	                        </svg></div>
	            <div class="swiper-button-prev" slot="button-prev">
	              <svg class="swiper-button__arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8">
	                            <path fill="#1D1D1B" fill-rule="evenodd" d="M0 4l4-4v3h12v2H4v3z"/>
	                        </svg>
	            </div>

	        </swiper>
	    </div>
	    <div v-else class="c-accommodation-search__img-holder">
	      <picture>
	        <img
	          class="c-accommodation-search__img"
	          :src="accommodation.meta.main_picture.mainImagePath"
	          alt="alt"
	        />
	      </picture>
	    </div>

	    <div class="c-accommodation-search__texts">
	      <h1 class="c-accommodation-search__title">
	        <span class="c-accommodation-search__link">{{accommodation.meta.name}}</span>
	      </h1>

	      <div class="c-accommodation-search__info-wrap">



		      <div v-if="accommodation && accommodation.meta && accommodation.meta.city && accommodation.meta.city['1'] && accommodation.meta.city['1'].name"
		           class="c-accommodation-search__ratings"
		      >
			      <div class="c-accommodation-search__stars">
				      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					      <g clip-path="url(#clip0_1525_1028)">
						      <path d="M12 1.5C9.81273 1.50248 7.71575 2.37247 6.16911 3.91911C4.62247 5.46575 3.75248 7.56273 3.75 9.75C3.75 16.8094 11.25 22.1409 11.5697 22.3641C11.6958 22.4524 11.846 22.4998 12 22.4998C12.154 22.4998 12.3042 22.4524 12.4303 22.3641C12.75 22.1409 20.25 16.8094 20.25 9.75C20.2475 7.56273 19.3775 5.46575 17.8309 3.91911C16.2843 2.37247 14.1873 1.50248 12 1.5ZM12 6.75C12.5933 6.75 13.1734 6.92595 13.6667 7.25559C14.1601 7.58524 14.5446 8.05377 14.7716 8.60195C14.9987 9.15013 15.0581 9.75333 14.9424 10.3353C14.8266 10.9172 14.5409 11.4518 14.1213 11.8713C13.7018 12.2909 13.1672 12.5766 12.5853 12.6924C12.0033 12.8081 11.4001 12.7487 10.8519 12.5216C10.3038 12.2946 9.83524 11.9101 9.50559 11.4167C9.17595 10.9234 9 10.3433 9 9.75C9 8.95435 9.31607 8.19129 9.87868 7.62868C10.4413 7.06607 11.2044 6.75 12 6.75Z" fill="#5DC5F1"/>
					      </g>
					      <defs>
						      <clipPath id="clip0_1525_1028">
							      <rect width="24" height="24" fill="white"/>
						      </clipPath>
					      </defs>
				      </svg>
			      </div>
			      <span class="c-accommodation-search__ratings-text">
						{{accommodation.meta.city['1'].name}}, {{accommodation.meta.region}}
				</span>
		      </div>

		      <!-- TODO Josip - accommodation type -->
	          <!-- v-if="accommodation.meta.stars !== undefined && accommodation.meta.stars != '' " -->
	        <div v-if="accommodation.content.object_type !== undefined && accommodation.content.object_type != ''"
	          class="c-accommodation-search__ratings"
	        >
		        <div class="c-accommodation-search__stars">
		        	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		        		<path d="M9 0L0 8.34854H2.12031V18H6.65815V10.8312H11.3418V18H15.8797V15.1454V8.34854H18L9 0Z" fill="#5DC5F1"/>
		        	</svg>
		        </div>
				<span class="c-accommodation-search__ratings-text">
						{{accommodation.content.object_type}}
				</span>
	        </div>

	        <!-- TODO Josip - amenities -->
	          <!-- v-if="accommodation.meta.stars !== undefined && accommodation.meta.stars != '' " -->
	        <div v-if="accommodation.meta.ammenity !== undefined && accommodation.meta.ammenity != '' && accommodation.meta.ammenity != 'undefined' "
	          class="c-accommodation-search__ratings"
	        >
		        <div class="c-accommodation-search__stars">
		        	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		        		<path d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z" fill="#5DC5F1"/>
		        		<path d="M3.87866 9.35093L7.02451 12.4968L13.628 5.89331" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
		        	</svg>
		        </div>
	          <span v-for="(item) in accommodation.meta.ammenity"
			  		 :key="item" class="c-accommodation-search__ratings-text">
	           		{{msg["search_ammenity_"+item]}}
	          </span>
	        </div>


	        <div
	          v-if="parseInt(accommodation.meta.stars)"
	          class="c-accommodation-search__ratings"
	        >
	          <div class="c-accommodation-search__stars">
	            <svg
	              v-for="stars in parseInt(accommodation.meta.stars)"
	              :key="stars"
	              xmlns="http://www.w3.org/2000/svg"
	              width="17"
	              height="16"
	              viewBox="0 0 17 16"
	            >
	              <polygon
	                fill="#5DC5F1"
	                fill-rule="evenodd"
	                points="54.5 12.135 49.504 15.377 51.043 9.623 46.416 5.873 52.363 5.559 54.5 0 56.637 5.559 62.584 5.873 57.957 9.623 59.496 15.377"
	                transform="translate(-46)"
	              />
	            </svg>
	          </div>
	          <span class="c-accommodation-search__ratings-text">
	            Rating
	            <strong>{{accommodation.meta.stars}} stars</strong>
	          </span>
	        </div>











		      <div
			      v-if="accommodation.meta.size_sqm !== undefined && accommodation.meta.size_sqm != '' "
			      class="c-accommodation-search__ratings"
		      >
			      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				      <g clip-path="url(#clip0_1525_1031)">
					      <path d="M13.5 11.25V19.5C13.5 19.6989 13.421 19.8897 13.2803 20.0303C13.1397 20.171 12.9489 20.25 12.75 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V11.25C3.75 11.0511 3.82902 10.8603 3.96967 10.7197C4.11032 10.579 4.30109 10.5 4.5 10.5H12.75C12.9489 10.5 13.1397 10.579 13.2803 10.7197C13.421 10.8603 13.5 11.0511 13.5 11.25ZM19.5 16.5C19.3011 16.5 19.1103 16.579 18.9697 16.7197C18.829 16.8603 18.75 17.0511 18.75 17.25V18.75H16.5C16.3011 18.75 16.1103 18.829 15.9697 18.9697C15.829 19.1103 15.75 19.3011 15.75 19.5C15.75 19.6989 15.829 19.8897 15.9697 20.0303C16.1103 20.171 16.3011 20.25 16.5 20.25H18.75C19.1478 20.25 19.5294 20.092 19.8107 19.8107C20.092 19.5294 20.25 19.1478 20.25 18.75V17.25C20.25 17.0511 20.171 16.8603 20.0303 16.7197C19.8897 16.579 19.6989 16.5 19.5 16.5ZM19.5 9.75C19.3011 9.75 19.1103 9.82902 18.9697 9.96967C18.829 10.1103 18.75 10.3011 18.75 10.5V13.5C18.75 13.6989 18.829 13.8897 18.9697 14.0303C19.1103 14.171 19.3011 14.25 19.5 14.25C19.6989 14.25 19.8897 14.171 20.0303 14.0303C20.171 13.8897 20.25 13.6989 20.25 13.5V10.5C20.25 10.3011 20.171 10.1103 20.0303 9.96967C19.8897 9.82902 19.6989 9.75 19.5 9.75ZM18.75 3.75H17.25C17.0511 3.75 16.8603 3.82902 16.7197 3.96967C16.579 4.11032 16.5 4.30109 16.5 4.5C16.5 4.69891 16.579 4.88968 16.7197 5.03033C16.8603 5.17098 17.0511 5.25 17.25 5.25H18.75V6.75C18.75 6.94891 18.829 7.13968 18.9697 7.28033C19.1103 7.42098 19.3011 7.5 19.5 7.5C19.6989 7.5 19.8897 7.42098 20.0303 7.28033C20.171 7.13968 20.25 6.94891 20.25 6.75V5.25C20.25 4.85218 20.092 4.47064 19.8107 4.18934C19.5294 3.90804 19.1478 3.75 18.75 3.75ZM13.5 3.75H10.5C10.3011 3.75 10.1103 3.82902 9.96967 3.96967C9.82902 4.11032 9.75 4.30109 9.75 4.5C9.75 4.69891 9.82902 4.88968 9.96967 5.03033C10.1103 5.17098 10.3011 5.25 10.5 5.25H13.5C13.6989 5.25 13.8897 5.17098 14.0303 5.03033C14.171 4.88968 14.25 4.69891 14.25 4.5C14.25 4.30109 14.171 4.11032 14.0303 3.96967C13.8897 3.82902 13.6989 3.75 13.5 3.75ZM4.5 8.25C4.69891 8.25 4.88968 8.17098 5.03033 8.03033C5.17098 7.88968 5.25 7.69891 5.25 7.5V5.25H6.75C6.94891 5.25 7.13968 5.17098 7.28033 5.03033C7.42098 4.88968 7.5 4.69891 7.5 4.5C7.5 4.30109 7.42098 4.11032 7.28033 3.96967C7.13968 3.82902 6.94891 3.75 6.75 3.75H5.25C4.85218 3.75 4.47064 3.90804 4.18934 4.18934C3.90804 4.47064 3.75 4.85218 3.75 5.25V7.5C3.75 7.69891 3.82902 7.88968 3.96967 8.03033C4.11032 8.17098 4.30109 8.25 4.5 8.25Z" fill="#5DC5F1"/>
				      </g>
				      <defs>
					      <clipPath id="clip0_1525_1031">
						      <rect width="24" height="24" fill="white"/>
					      </clipPath>
				      </defs>
			      </svg>

			      <span class="c-accommodation-search__ratings-text">
	            {{msg.accommodation_size_sqm}}
	            <strong>{{accommodation.meta.size_sqm}}m<sup>2</sup> / {{Math.round(accommodation.meta.size_sqm * 10.7639)}}ft<sup>2</sup></strong>
	          </span>
		      </div>


		      <div
			      v-if="accommodation.meta.bed_count !== undefined && accommodation.meta.bed_count != '' "
			      class="c-accommodation-search__ratings"
		      >
			      <svg width="50" height="24" viewBox="0 0 50 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				      <text x="0" y="18" font-family="Arial, sans-serif" font-weight="bold" font-size="18" fill="#87CEFA">{{accommodation.meta.bed_count}}</text>
			      </svg>

			      <span class="c-accommodation-search__ratings-text">
	            {{msg.accommodation_bed_count}}
	          </span>
		      </div>

		      <div
			      v-if="accommodation.meta.room_count !== undefined && accommodation.meta.room_count != '' "
			      class="c-accommodation-search__ratings"
		      >
			      <svg width="50" height="24" viewBox="0 0 50 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				      <text x="0" y="18" font-family="Arial, sans-serif" font-weight="bold" font-size="18" fill="#87CEFA">{{accommodation.meta.room_count}}</text>
			      </svg>

			      <span class="c-accommodation-search__ratings-text">
	            {{msg.accommodation_room_count}}
	          </span>
		      </div>




		      <div
	          v-if="accommodation.meta.capacity !== undefined && accommodation.meta.capacity != '' "
	          class="c-accommodation-search__ratings"
	        >
	          <div class="c-accommodation-search__capacity">
	            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
	              <path
	                fill="#5DC5F1"
	                fill-rule="evenodd"
	                d="M9,13.25 C12.00375,13.25 18,14.7575 18,17.75 L18,20 L0,20 L0,17.75 C0,14.7575 5.99625,13.25 9,13.25 Z M9,11 C6.51471863,11 4.5,8.98528137 4.5,6.5 C4.5,4.01471863 6.51471863,2 9,2 C11.4852814,2 13.5,4.01471863 13.5,6.5 C13.5,8.98528137 11.4852814,11 9,11 Z"
	                transform="translate(0 -2)"
	              />
	            </svg>
	          </div>
	          <span class="c-accommodation-search__ratings-text">
	            {{msg.accommodation_capacity}}
	            <strong>{{accommodation.meta.capacity}}pax</strong>
	          </span>
	        </div>
<!--		    ###################################################################  -->

		      <div
			      v-if="accommodation.meta.type !== undefined && accommodation.meta.type != '' && getCategoryNameById(accommodation.meta.type) !=='' "
			      class="c-accommodation-search__ratings"
		      >
			      <div class="c-accommodation-search__capacity">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 3L3 11.3485H5.12031V21H9.65815V13.8312H14.3418V21H18.8797V18.1454V11.3485H21L12 3Z" fill="#5DC5F1"/>
                      </svg>
                  </div>
			      <span class="c-accommodation-search__ratings-text">
	            {{getCategoryNameById(accommodation.meta.type)}}
	          </span>
		      </div>



		      <div
			      v-if="accommodation.content.michelin !== undefined && accommodation.content.michelin != '' "
			      class="c-accommodation-search__ratings"
		      >
			      <div class="c-accommodation-search__capacity">
				      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					      <path d="M18.5209 12.0989C18.4617 12.0653 18.3966 12.0332 18.3294 12.0018C18.3966 11.9704 18.4617 11.9382 18.5209 11.9047C18.8562 11.7185 19.1505 11.4693 19.3868 11.1716C19.6231 10.8739 19.7968 10.5334 19.8978 10.1699C19.9989 9.80633 20.0253 9.42684 19.9756 9.05327C19.9259 8.6797 19.801 8.31942 19.6082 7.99317C19.4153 7.66693 19.1583 7.38117 18.8519 7.15234C18.5455 6.92351 18.1958 6.75613 17.823 6.65984C17.4501 6.56355 17.0614 6.54025 16.6793 6.59128C16.2971 6.64232 15.9291 6.76667 15.5964 6.9572C15.5371 6.99076 15.4757 7.02861 15.415 7.07074C15.4209 6.99933 15.4246 6.92792 15.4246 6.85651C15.4246 6.09891 15.1164 5.37235 14.568 4.83665C14.0195 4.30095 13.2756 4 12.5 4C11.7244 4 10.9805 4.30095 10.432 4.83665C9.88357 5.37235 9.57545 6.09891 9.57545 6.85651C9.57545 6.92363 9.57545 6.99505 9.58495 7.07074C9.52427 7.03004 9.46285 6.99076 9.40363 6.9572C9.0709 6.76667 8.70288 6.64232 8.32074 6.59128C7.93861 6.54025 7.54991 6.56355 7.17703 6.65984C6.80415 6.75613 6.45446 6.92351 6.14808 7.15234C5.8417 7.38117 5.58468 7.66693 5.39183 7.99317C5.19899 8.31942 5.07411 8.6797 5.0244 9.05327C4.97468 9.42684 5.00111 9.80633 5.10217 10.1699C5.20322 10.5334 5.3769 10.8739 5.61321 11.1716C5.84952 11.4693 6.14379 11.7185 6.47908 11.9047C6.5383 11.9382 6.60337 11.9704 6.67063 12.0018C6.60337 12.0332 6.5383 12.0653 6.47908 12.0989C6.14379 12.2851 5.84952 12.5342 5.61321 12.832C5.3769 13.1297 5.20322 13.4701 5.10217 13.8337C5.00111 14.1972 4.97468 14.5767 5.0244 14.9503C5.07411 15.3239 5.19899 15.6842 5.39183 16.0104C5.58468 16.3366 5.8417 16.6224 6.14808 16.8512C6.45446 17.0801 6.80415 17.2474 7.17703 17.3437C7.54991 17.44 7.93861 17.4633 8.32074 17.4123C8.70288 17.3613 9.0709 17.2369 9.40363 17.0464C9.46285 17.0128 9.52427 16.975 9.58495 16.9328C9.5791 17.0042 9.57545 17.0757 9.57545 17.1435C9.57545 17.9011 9.88357 18.6277 10.432 19.1633C10.9805 19.699 11.7244 20 12.5 20C13.2756 20 14.0195 19.699 14.568 19.1633C15.1164 18.6277 15.4246 17.9011 15.4246 17.1435C15.4246 17.0764 15.4209 17.005 15.415 16.9328C15.4757 16.9735 15.5371 17.0128 15.5964 17.0464C16.0394 17.297 16.5423 17.4291 17.0543 17.4291C17.3115 17.4288 17.5676 17.3957 17.8161 17.3306C18.3748 17.1843 18.8766 16.8795 19.2579 16.4547C19.6393 16.0299 19.8831 15.5042 19.9586 14.944C20.034 14.3839 19.9377 13.8145 19.6818 13.3078C19.4259 12.8011 19.0219 12.3799 18.5209 12.0975V12.0989ZM12.5 14.0013C12.0951 14.0013 11.6993 13.8841 11.3626 13.6644C11.026 13.4446 10.7636 13.1324 10.6086 12.767C10.4537 12.4016 10.4132 11.9996 10.4921 11.6117C10.5711 11.2238 10.7661 10.8675 11.0524 10.5879C11.3387 10.3082 11.7035 10.1178 12.1006 10.0407C12.4977 9.9635 12.9093 10.0031 13.2834 10.1544C13.6575 10.3058 13.9772 10.5621 14.2022 10.8909C14.4271 11.2197 14.5472 11.6063 14.5472 12.0018C14.5472 12.5321 14.3315 13.0407 13.9476 13.4157C13.5637 13.7907 13.0429 14.0013 12.5 14.0013Z" fill="#5DC5F1"/>
				      </svg>

			      </div>
			      <span class="c-accommodation-search__ratings-text">
	            {{accommodation.content.michelin}}
	          </span>
		      </div>


		      <div
			      v-if="accommodation.content.falstaff !== undefined && accommodation.content.falstaff != '' "
			      class="c-accommodation-search__ratings"
		      >
			      <div class="c-accommodation-search__capacity">
				      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					      <path d="M20 4.64996V19.3604C20 19.53 19.9313 19.6927 19.809 19.8127C19.6867 19.9326 19.5208 20 19.3478 20C19.1749 20 19.009 19.9326 18.8867 19.8127C18.7644 19.6927 18.6957 19.53 18.6957 19.3604V15.5229H14.7826C14.6096 15.5229 14.4438 15.4555 14.3215 15.3356C14.1991 15.2156 14.1304 15.0529 14.1304 14.8833C14.1607 13.3513 14.358 11.8268 14.719 10.3359C15.5163 7.09877 17.0277 4.92898 19.091 4.06234C19.1902 4.02068 19.2984 4.0038 19.4058 4.01321C19.5133 4.02262 19.6167 4.05803 19.7068 4.11626C19.7968 4.17449 19.8708 4.25373 19.922 4.34687C19.9731 4.44002 20 4.54416 20 4.64996ZM12.1649 4.54523C12.1522 4.46125 12.1225 4.3806 12.0776 4.30799C12.0327 4.23538 11.9735 4.17227 11.9035 4.12233C11.8335 4.07239 11.754 4.03662 11.6697 4.01711C11.5855 3.9976 11.4981 3.99474 11.4127 4.0087C11.3273 4.02266 11.2456 4.05316 11.1723 4.09841C11.0991 4.14367 11.0357 4.20278 10.986 4.27229C10.9363 4.34181 10.9012 4.42033 10.8827 4.50329C10.8643 4.58626 10.8628 4.67199 10.8785 4.75549L11.5128 8.48747H9.56522V4.64996C9.56522 4.48033 9.49651 4.31765 9.3742 4.19771C9.25189 4.07776 9.08601 4.01038 8.91304 4.01038C8.74008 4.01038 8.57419 4.07776 8.45189 4.19771C8.32958 4.31765 8.26087 4.48033 8.26087 4.64996V8.48747H6.31332L6.94755 4.75549C6.96325 4.67199 6.96182 4.58626 6.94337 4.50329C6.92492 4.42033 6.88981 4.34181 6.84009 4.27229C6.79037 4.20278 6.72703 4.14367 6.65377 4.09841C6.58052 4.05316 6.4988 4.02266 6.4134 4.0087C6.32799 3.99474 6.24061 3.9976 6.15634 4.01711C6.07208 4.03662 5.99261 4.07239 5.92259 4.12233C5.85257 4.17227 5.79339 4.23538 5.7485 4.30799C5.70361 4.3806 5.67391 4.46125 5.66114 4.54523L5.00897 8.38274C5.00311 8.41736 5.00012 8.45238 5 8.48747C5.0013 9.39393 5.32928 10.2708 5.92598 10.963C6.52268 11.6553 7.34969 12.1184 8.26087 12.2706V19.3604C8.26087 19.53 8.32958 19.6927 8.45189 19.8127C8.57419 19.9326 8.74008 20 8.91304 20C9.08601 20 9.25189 19.9326 9.3742 19.8127C9.49651 19.6927 9.56522 19.53 9.56522 19.3604V12.2706C10.4764 12.1184 11.3034 11.6553 11.9001 10.963C12.4968 10.2708 12.8248 9.39393 12.8261 8.48747C12.826 8.45238 12.823 8.41736 12.8171 8.38274L12.1649 4.54523Z" fill="#5DC5F1"/>
				      </svg>


			      </div>
			      <span class="c-accommodation-search__ratings-text">
	            {{accommodation.content.falstaff}}
	          </span>
		      </div>



		      <div
			      v-if="accommodation.content.gault_and_millau !== undefined && accommodation.content.gault_and_millau != '' "
			      class="c-accommodation-search__ratings"
		      >
			      <div class="c-accommodation-search__capacity">
				      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					      <path d="M21 11.0391C20.9987 9.85125 20.5242 8.71237 19.6805 7.87241C18.8368 7.03244 17.6929 6.55999 16.4997 6.55871C16.3575 6.55871 16.2152 6.56672 16.0746 6.57952C15.7118 5.80847 15.1357 5.15633 14.414 4.69948C13.6923 4.24263 12.8547 4 11.9995 4C11.1442 4 10.3067 4.24263 9.58492 4.69948C8.86319 5.15633 8.28716 5.80847 7.9243 6.57952C7.78367 6.56672 7.64143 6.55871 7.49919 6.55871C6.47761 6.55896 5.48651 6.90524 4.68882 7.54064C3.89113 8.17604 3.33432 9.06273 3.10992 10.055C2.88552 11.0472 3.00688 12.0859 3.45406 13.0004C3.90123 13.9148 4.64761 14.6506 5.5705 15.0867V18.7199C5.5705 19.0594 5.70596 19.385 5.9471 19.6251C6.18823 19.8651 6.51528 20 6.85629 20H17.1426C17.4836 20 17.8107 19.8651 18.0518 19.6251C18.2929 19.385 18.4284 19.0594 18.4284 18.7199V15.0867C19.1972 14.7227 19.8468 14.1493 20.3019 13.433C20.757 12.7167 20.999 11.8867 21 11.0391ZM13.9474 13.4442L14.5903 10.8839C14.634 10.7218 14.7399 10.5833 14.8852 10.4981C15.0305 10.413 15.2036 10.3881 15.3672 10.4288C15.5308 10.4695 15.6717 10.5726 15.7597 10.7158C15.8477 10.859 15.8756 11.0308 15.8375 11.1944L15.1946 13.7546C15.1599 13.8931 15.0796 14.016 14.9666 14.1039C14.8536 14.1917 14.7144 14.2394 14.571 14.2394C14.5182 14.2394 14.4656 14.2329 14.4143 14.2202C14.2491 14.1789 14.1071 14.0739 14.0196 13.9284C13.932 13.7829 13.9061 13.6087 13.9474 13.4442ZM11.3566 11.0391C11.3566 10.8694 11.4243 10.7066 11.5449 10.5866C11.6654 10.4665 11.829 10.3991 11.9995 10.3991C12.17 10.3991 12.3335 10.4665 12.4541 10.5866C12.5746 10.7066 12.6424 10.8694 12.6424 11.0391V13.5994C12.6424 13.7691 12.5746 13.9319 12.4541 14.052C12.3335 14.172 12.17 14.2394 11.9995 14.2394C11.829 14.2394 11.6654 14.172 11.5449 14.052C11.4243 13.9319 11.3566 13.7691 11.3566 13.5994V11.0391ZM8.62908 10.4183C8.79447 10.3771 8.9695 10.4031 9.11568 10.4904C9.26186 10.5777 9.36722 10.7193 9.40859 10.8839L10.0515 13.4442C10.0928 13.6088 10.0667 13.7831 9.97904 13.9286C9.89133 14.0742 9.74915 14.1791 9.58378 14.2202C9.53121 14.2333 9.47722 14.2397 9.42305 14.2394C9.27983 14.2392 9.14077 14.1914 9.02794 14.1036C8.91511 14.0158 8.83498 13.8929 8.80025 13.7546L8.15735 11.1944C8.13695 11.1126 8.13298 11.0276 8.14567 10.9442C8.15836 10.8609 8.18745 10.7809 8.23128 10.7088C8.27511 10.6367 8.33282 10.5739 8.40108 10.524C8.46934 10.4742 8.54683 10.4382 8.62908 10.4183ZM17.1426 18.7199H6.85629V15.4732C7.06918 15.5041 7.28404 15.5196 7.49919 15.5196H16.4997C16.7149 15.5196 16.9297 15.5041 17.1426 15.4732V18.7199Z" fill="#5DC5F1"/>
				      </svg>

			      </div>
			      <span class="c-accommodation-search__ratings-text">
	            {{accommodation.content.gault_and_millau}}
	          </span>
		      </div>


              <div
                  v-if="accommodation.content.jre !== undefined && accommodation.content.jre != '' "
                  class="c-accommodation-search__ratings"
              >
                  <div class="c-accommodation-search__capacity">

                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.875 7.07692V4.61538C8.875 4.45217 8.94085 4.29565 9.05806 4.18024C9.17527 4.06483 9.33424 4 9.5 4C9.66576 4 9.82473 4.06483 9.94194 4.18024C10.0592 4.29565 10.125 4.45217 10.125 4.61538V7.07692C10.125 7.24013 10.0592 7.39666 9.94194 7.51207C9.82473 7.62747 9.66576 7.69231 9.5 7.69231C9.33424 7.69231 9.17527 7.62747 9.05806 7.51207C8.94085 7.39666 8.875 7.24013 8.875 7.07692ZM12 7.69231C12.1658 7.69231 12.3247 7.62747 12.4419 7.51207C12.5592 7.39666 12.625 7.24013 12.625 7.07692V4.61538C12.625 4.45217 12.5592 4.29565 12.4419 4.18024C12.3247 4.06483 12.1658 4 12 4C11.8342 4 11.6753 4.06483 11.5581 4.18024C11.4408 4.29565 11.375 4.45217 11.375 4.61538V7.07692C11.375 7.24013 11.4408 7.39666 11.5581 7.51207C11.6753 7.62747 11.8342 7.69231 12 7.69231ZM14.5 7.69231C14.6658 7.69231 14.8247 7.62747 14.9419 7.51207C15.0592 7.39666 15.125 7.24013 15.125 7.07692V4.61538C15.125 4.45217 15.0592 4.29565 14.9419 4.18024C14.8247 4.06483 14.6658 4 14.5 4C14.3342 4 14.1753 4.06483 14.0581 4.18024C13.9408 4.29565 13.875 4.45217 13.875 4.61538V7.07692C13.875 7.24013 13.9408 7.39666 14.0581 7.51207C14.1753 7.62747 14.3342 7.69231 14.5 7.69231ZM21.875 10.4C21.7755 10.2694 21.6275 10.1831 21.4634 10.16C21.2993 10.137 21.1326 10.179 21 10.2769L19.5 11.3846V9.53846C19.5 9.37525 19.4342 9.21873 19.3169 9.10332C19.1997 8.98791 19.0408 8.92308 18.875 8.92308H5.125C4.95924 8.92308 4.80027 8.98791 4.68306 9.10332C4.56585 9.21873 4.5 9.37525 4.5 9.53846V11.3846L3 10.2769C2.86739 10.179 2.70071 10.137 2.53661 10.16C2.37252 10.1831 2.22446 10.2694 2.125 10.4C2.02555 10.5306 1.98284 10.6947 2.00628 10.8563C2.02973 11.0178 2.11739 11.1636 2.25 11.2615L4.5 12.9231V17.5385C4.5 18.1913 4.76339 18.8174 5.23224 19.279C5.70108 19.7407 6.33696 20 7 20H17C17.663 20 18.2989 19.7407 18.7678 19.279C19.2366 18.8174 19.5 18.1913 19.5 17.5385V12.9231L21.75 11.2615C21.8157 11.2131 21.871 11.1523 21.9128 11.0828C21.9546 11.0132 21.9821 10.9363 21.9937 10.8563C22.0053 10.7763 22.0008 10.6948 21.9804 10.6165C21.9601 10.5382 21.9242 10.4647 21.875 10.4Z" fill="#5DC5F1"/>
                      </svg>


                  </div>
                  <span class="c-accommodation-search__ratings-text">
	            {{accommodation.content.jre}}
	          </span>
              </div>


              <div
                  v-if="accommodation.content.pag_na_meniju !== undefined && accommodation.content.pag_na_meniju != '' "
                  class="c-accommodation-search__ratings"
              >
                  <div class="c-accommodation-search__capacity">

                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16.75 5C16.6909 4.99984 16.632 5.00871 16.5754 5.02631L4.43259 8.7406C4.30757 8.77886 4.19798 8.85718 4.12006 8.96395C4.04214 9.07072 4.00004 9.20025 4 9.33333V10.5714C4 10.7356 4.06397 10.8931 4.17783 11.0092C4.29169 11.1253 4.44612 11.1905 4.60714 11.1905H5.1733C6.19406 11.1905 7.05469 12.0417 7.03571 13.0832C7.02657 13.5696 6.83064 14.0328 6.49004 14.3735C6.14944 14.7141 5.69137 14.9049 5.21429 14.9048H4.60714C4.44612 14.9048 4.29169 14.97 4.17783 15.0861C4.06397 15.2022 4 15.3596 4 15.5238V17.381C4 17.5451 4.06397 17.7026 4.17783 17.8187C4.29169 17.9348 4.44612 18 4.60714 18H19.7857C20.1078 18 20.4166 17.8696 20.6443 17.6374C20.8721 17.4052 21 17.0903 21 16.7619V9.33333C20.9988 8.18444 20.5506 7.08295 19.7539 6.27056C18.9571 5.45817 17.8768 5.00123 16.75 5ZM8.85714 16.7619C8.85714 16.1052 9.11301 15.4754 9.56845 15.011C10.0239 14.5466 10.6416 14.2857 11.2857 14.2857C11.9298 14.2857 12.5475 14.5466 13.003 15.011C13.4584 15.4754 13.7143 16.1052 13.7143 16.7619H8.85714ZM15.5357 13.0476C15.165 13.0478 14.7991 12.9615 14.4662 12.7952C14.1332 12.6289 13.842 12.3871 13.6149 12.0883C13.3878 11.7895 13.2308 11.4416 13.1559 11.0714C13.0811 10.7012 13.0903 10.3184 13.183 9.95238H17.8884C17.9811 10.3184 17.9903 10.7012 17.9155 11.0714C17.8406 11.4416 17.6836 11.7895 17.4565 12.0883C17.2294 12.3871 16.9382 12.6289 16.6053 12.7952C16.2723 12.9615 15.9065 13.0478 15.5357 13.0476ZM8.74406 8.71429L16.835 6.2381C17.5198 6.25857 18.1777 6.51426 18.7021 6.9637C19.2265 7.41315 19.5867 8.03001 19.7242 8.71429H8.74406Z" fill="#5DC5F1"/>
                      </svg>

                  </div>
                  <span class="c-accommodation-search__ratings-text">
	            {{accommodation.content.pag_na_meniju}}
	          </span>
              </div>

		      <!--		    ###################################################################  -->


	      </div>

	      <hr />
	      <div class="c-accommodation-search__list">
		      <div class="c-accommodation-search__list-item-wrap" v-if="accommodation && accommodation.content && accommodation.content.custom_string_label !=='' && accommodation.content.custom_string_text !== ''">
			      <dt class="c-accommodation-search__list-item-title">{{accommodation.content.custom_string_label}}</dt>
			      <dd
				      class="c-accommodation-search__list-item-description"
			      >{{accommodation.content.custom_string_text}}</dd>
		      </div>
	        <div class="c-accommodation-search__list-item-wrap">
	          <dt class="c-accommodation-search__list-item-title">{{msg.block_label_adress}}</dt>
	          <dd
	            class="c-accommodation-search__list-item-description"
	          >{{accommodation.meta.address}}, {{accommodation.meta.post_code}} {{ cityName }}</dd>
	        </div>
	        <div class="c-accommodation-search__list-item-wrap">
	          <dt class="c-accommodation-search__list-item-title">{{msg.block_label_phone}}</dt>
	          <dd class="c-accommodation-search__list-item-description">{{accommodation.meta.contact}}</dd>
	        </div>
	        <div
	          v-if="accommodation.meta.email !== undefined"
	          class="c-accommodation-search__list-item-wrap"
	        >
	          <dt class="c-accommodation-search__list-item-title">{{msg.block_label_email}}</dt>
	          <dd class="c-accommodation-search__list-item-description">
	            <a :href="'mailto:' + accommodation.meta.email">{{accommodation.meta.email}}</a>
	          </dd>
	        </div>
	        <div
	          v-if="accommodation.meta.web_link !== '' && accommodation.meta.web_link !== undefined"
	          class="c-accommodation-search__list-item-wrap"
	        >
	          <dt class="c-accommodation-search__list-item-title">{{msg.block_label_website}}</dt>
	          <dd class="c-accommodation-search__list-item-description">
	            <a :href="accommodation.meta.web_link | urlChecker" target="_blank">{{accommodation.meta.web_link}}</a>
	          </dd>
	        </div>
	      </div>
	    </div>

	  </div>

		<div v-if="accommodation.accessibility" class="accessibility-accordion">
			<div class="accessibility-accordion__header">
				<button
					type="button"
					class="accessibility-accordion__toggle"
					:aria-expanded="accessibilityOpen ? 'true' : 'false'"
					:aria-controls="'accessibility-' + accommodation.apartments_id"
					@click="accessibilityOpen = !accessibilityOpen"
				>
					<span class="accessibility-accordion__title">{{msg.search_ammenity_accessibility}}</span>
					<span class="accessibility-accordion__icon" aria-hidden="true"></span>
				</button>
			</div>

			<div v-show="accessibilityOpen" :id="'accessibility-' + accommodation.apartments_id" class="accessibility-accordion__body">

				<ul v-if="accommodation.accessibility.main.length" class="accessibility-accordion__main-list">
					<li v-for="(row, index) in accommodation.accessibility.main" :key="index">
						<span>{{row.label}}</span>
						<span>{{row.value}}</span>
					</li>
				</ul>

				<template v-if="accommodation.accessibility.other.length">
					<p class="accessibility-accordion__additional-title">
						{{msg.accessibility_other}}
					</p>

					<ul class="accessibility-accordion__additional-list">
						<li v-for="(item, index) in accommodation.accessibility.other" :key="index">
							{{item}}
						</li>
					</ul>
				</template>

			</div>
		</div>

		<div class="vsa-list-wrap" v-if="accordionData.length != 0">
		  <vsa-list>
			  <!-- Here you can use v-for to loop through items  -->
			  <vsa-item v-for="(item, index) in accordionData" :key="index">
				  <vsa-heading>
					  {{ item.heading }}
				  </vsa-heading>
				  <vsa-content>
					  <div class="table-container" role="table" aria-label="">
						  <!-- First data row -->
						  <div class="flex-table row-group" role="rowgroup">
							  <div class="flex-cell flex-cell--wide" role="cell">{{ item.firstDataRow.left }}</div>
							  <div class="flex-cell" role="cell">{{ item.firstDataRow.right }}</div>
						  </div>
						  <!-- Header row -->
						  <div class="flex-table header" role="rowgroup">
							  <div class="flex-cell flex-cell--wide flex-cell--accent" role="columnheader">{{ item.headerRow.left }}</div>
							  <div class="flex-cell flex-cell--accent" role="columnheader">{{ item.headerRow.right }}</div>
						  </div>
						  <!-- Data rows -->
						  <div v-for="(row, rowIndex) in item.dataRows" :key="rowIndex" class="flex-table row-group" role="rowgroup">
							  <div class="flex-cell flex-cell--wide" role="cell">{{ row.left }}</div>
							  <div class="flex-cell" role="cell">{{ row.right }}</div>
						  </div>
					  </div>
				  </vsa-content>
			  </vsa-item>
		  </vsa-list>

	  </div>

	</div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapState } from "vuex";

export default {
  props: {
    accommodation: Object,
	  categories: {
		  type: Array, // ✅ Change Object to Array
		  default: () => [] // ✅ Ensure it defaults to an empty array
	  }
  },
   components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      accessibilityOpen: false,
      //
      swiperOption: {
        fixedHeight: 380,
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction'
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
      }
    };
  },
  methods: {
    showModal() {
      this.$store.commit("toggleAccommodationModal");
    },
	  getCategoryNameById(id) {
		  const category = this.categories.find(cat => cat.id === id);
		  return category ? category.name : "";
	  }
  },
  computed: {
	...mapState({
		msg: state => state.msg
	}),
	  cityName() {
		  // Check if accommodation, city_meta, and name exist, and return the value or an empty string
		  return this.accommodation && this.accommodation.city_meta && this.accommodation.city_meta.name
			  ? this.accommodation.city_meta.name
			  : '';
	  },
	accordionData() {
		  const repeater = this.accommodation.content.repeater;
		  if (!repeater || !repeater.rows) {
			  return [];
		  }
		  return repeater.rows
			  .map(item => {
				  const itemCols = item.cols;
				  if (!itemCols || !itemCols[0] || !itemCols[0].data || !itemCols[0].data.value || !itemCols[0].data.value.rows) {
					  return null;
				  }
				  const contentRows = itemCols[0].data.value.rows;
				  if (!contentRows || contentRows.length === 0) {
					  return null;
				  }

				  const heading =
					  (contentRows[0] &&
						  contentRows[0].cols &&
						  contentRows[0].cols[0] &&
						  contentRows[0].cols[0].data &&
						  contentRows[0].cols[0].data.value) ||
					  '';
				  const firstDataRow = {
					  left:
						  (contentRows[1] &&
							  contentRows[1].cols &&
							  contentRows[1].cols[0] &&
							  contentRows[1].cols[0].data &&
							  contentRows[1].cols[0].data.value) ||
						  '',
					  right:
						  (contentRows[1] &&
							  contentRows[1].cols &&
							  contentRows[1].cols[1] &&
							  contentRows[1].cols[1].data &&
							  contentRows[1].cols[1].data.value) ||
						  ''
				  };
				  const headerRow = {
					  left:
						  (contentRows[2] &&
							  contentRows[2].cols &&
							  contentRows[2].cols[0] &&
							  contentRows[2].cols[0].data &&
							  contentRows[2].cols[0].data.value) ||
						  '',
					  right:
						  (contentRows[2] &&
							  contentRows[2].cols &&
							  contentRows[2].cols[1] &&
							  contentRows[2].cols[1].data &&
							  contentRows[2].cols[1].data.value) ||
						  ''
				  };
				  const dataRows = contentRows.slice(3).map(row => ({
					  left:
						  (row.cols &&
							  row.cols[0] &&
							  row.cols[0].data &&
							  row.cols[0].data.value) ||
						  '',
					  right:
						  (row.cols &&
							  row.cols[1] &&
							  row.cols[1].data &&
							  row.cols[1].data.value) ||
						  ''
				  }));
				  return {
					  heading,
					  firstDataRow,
					  headerRow,
					  dataRows
				  };
			  })
			  .filter(item => item !== null);
	  }
  },
  watch: {
	  // the list reuses cards by index - a new filter result must start with the accordion closed
	  'accommodation.apartments_id'() {
		  this.accessibilityOpen = false;
	  }
  },
  mounted() {
	  console.log('Accommodation data:', this.accommodation);
  },
};
</script>

<style lang="scss">
</style>
